// Code summary:
// This code creates an array window.SwymCallbacks or sets it to an empty array if it does not exist.
// Then, it pushes a callback function to this array.
// The callback function takes swat as an argument, which is a reference to the SWYM API.
// The function then finds the element with the ID swym-wishlist-render-container and uses it to render the user's wishlist.
// The code also gets the query parameters from the URL and passes them as the second argument to swat.ui.renderWishlistInContainer.
// This allows the code to render a specific list ID if it exists in the query parameters.

window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(function (swat) {
  var wishlistContainerElement = document.querySelector(
    "#swym-wishlist-render-container"
  );
  var queryParams = swat.utils.getEncodedAsObject(window.location.search);
  // Contains queryParams["lid"] to render a specific list id
  swat.ui.renderWishlistInContainer(wishlistContainerElement, queryParams);
});

//  Code summary:
// - The code adds an event listener to the window object that waits for all necessary resources to load.
// - Then, it executes the function onSwymLoadCallback. This function creates a button on the wishlist page, which is a way for users to request a quote for the items in their wishlist.
// - The code fetches the users wishlist and stores the relevant information such as product title, URL, and variant ID in a message.
// - This message is then passed as the value of a form input field. The form is created with the help of a third-party library (Hubspot).

window.addEventListener("load", () => {
  function onSwymLoadCallback(swat) {
    swat.fetch(
      (products) => {
        if (products.length > 0) {
          const wishListPopUp = document.querySelector(
            "#GymListPage .button__container"
          );
          wishListPopUp.classList.remove("hidden");
        }
      },
      (error) => {
        console.log("There was an error while fetching the wishlist", error);
      }
    );

    function fetchProductsOnClick() {
      swat.fetch(
        (products) => {
          let message = products.reduce((msg, product, index) => {
            return (
              msg +
              `${index + 1}) Product Title: ${
                product.dt
              }, Product URL with selected variant: ${
                product.du
              }, Variant ID: ${product.epi}, Product ID: ${
                product.empi
              }, Quantity: 1; \n`
            );
          }, "");

          if (hbspt) {
            console.log(
              `I'd like a quote for the following wishlisted product(s):\n ${message}`
            );
            hbspt.forms.create({
              region: "eu1",
              portalId: "25988075",
              formId: "248cdd8e-a7f5-4253-9966-b74061d5b26b",
              target: "#hbsp-form-container .form-wrapper",
              onFormReady: ($form) => {
                $('textarea[name="message"]')
                  .val(
                    `I'd like a quote for the following wishlisted products:\n ${message}`
                  )
                  .change();
              },
            });
          }
        },
        (error) => {
          console.log("There was an error while fetching the wishlist", error);
        }
      );
    }

    function createQuoteButton(popup, fetchProductsOnClick) {
      const quoteBtn = document.createElement("button");
      quoteBtn.classList =
        "button button-secondary button-secondary--light background--white";
      quoteBtn.id = "QuoteFormButton";
      quoteBtn.innerHTML = "Request a quote";
      popup.appendChild(quoteBtn);
      quoteBtn.addEventListener("click", fetchProductsOnClick);

      const formWrapper = "#hbsp-form-container";
      const buttons = ["#QuoteFormButton", ".form__close-btn"];
      const body = "body";
      new PopupForm(formWrapper, buttons.join(", "), body);
    }

    const wishListPopUp = document.querySelector(
      "#GymListPage .button__container"
    );
    createQuoteButton(wishListPopUp, fetchProductsOnClick);
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
});
